import posthog from "posthog-js"
import { track } from "@vercel/analytics"

export function isAnalyticsEnabled(): boolean {
  return Boolean(process.env.GATSBY_POSTHOG_KEY || "phc_AGuqGBfc85fuXm6iRcJ9QvcvXiWtky6quDHGNQLSBBUr")
}

function trackVercel(event: string, properties?: Record<string, unknown>): void {
  const toVercelProperties = (input?: Record<string, unknown>): Record<string, string | number | boolean | null> | undefined => {
    if (!input) return undefined
    const output: Record<string, string | number | boolean | null> = {}
    Object.entries(input).forEach(([key, value]) => {
      if (value === null || typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
        output[key] = value
        return
      }
      if (value !== undefined) {
        output[key] = JSON.stringify(value)
      }
    })
    return output
  }

  try {
    track(event, toVercelProperties(properties))
  } catch (error) {
    console.warn("Vercel analytics track failed:", error)
  }
}

/** Client-side product events (PostHog project key must be set at build time). */
export function capture(event: string, properties?: Record<string, unknown>): void {
  trackVercel(event, properties)
  if (isAnalyticsEnabled()) {
    posthog.capture(event, properties)
  }
}

export function captureInteraction(action: string, properties?: Record<string, unknown>): void {
  capture("UI Interaction", {
    action,
    ...(properties || {}),
  })
}

export function captureError(
  error: unknown,
  context: string,
  properties?: Record<string, unknown>
): void {
  const errorMessage = error instanceof Error ? error.message : String(error)
  const errorName = error instanceof Error ? error.name : "UnknownError"
  const errorStack = error instanceof Error ? error.stack : undefined
  const payload = {
    context,
    error_message: errorMessage,
    error_name: errorName,
    ...(errorStack ? { stack: errorStack } : {}),
    ...(properties || {}),
  }

  trackVercel("Client Error", payload)

  if (isAnalyticsEnabled()) {
    const maybeCaptureException = (posthog as unknown as { captureException?: (e: Error, p?: Record<string, unknown>) => void })
      .captureException
    if (error instanceof Error && typeof maybeCaptureException === "function") {
      maybeCaptureException(error, payload)
      return
    }

    posthog.capture("Client Error", payload)
  }
}
